// A wild boar, modelled facing +X: a bulky dark body tapering to a snout,
// short legs, a bristly back and small upturned tusks. Ported 1:1 from
// age-of-mcp's classic boar.ts, restoring its leg loop + body composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.05, 0.03], [0.05, -0.03], [-0.05, 0.03], [-0.05, -0.03]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.009, 0.008, 0.078, 4),
      color: "#2a2018", position: [x!, 0.039, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.058, 0), color: "#4a3a2a",
      position: [0, 0.078, 0], scale: [1.7, 1, 0.95] },                // bulky body
    { geometry: new THREE.ConeGeometry(0.04, 0.07, 5), color: "#3e3022",
      position: [0.09, 0.07, 0], rotation: [0, 0, -Math.PI / 2] },      // head/snout
    { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#1c1610",
      position: [0.125, 0.062, 0] },                                    // snout tip
    { geometry: new THREE.ConeGeometry(0.005, 0.02, 3), color: "#e8e0cf",
      position: [0.115, 0.07, 0.018], rotation: [0, 0, 0.6] },          // tusk
    { geometry: new THREE.ConeGeometry(0.005, 0.02, 3), color: "#e8e0cf",
      position: [0.115, 0.07, -0.018], rotation: [0, 0, 0.6] },
    // Bristly ridge along the back.
    { geometry: new THREE.ConeGeometry(0.01, 0.03, 4), color: "#1c1610",
      position: [0.01, 0.13, 0] },
  );
  return parts;
}

export const boar = defineModel({
  id: "boar",
  scale: 2.43, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Boar",
  tags: ["creature","boar","low-poly","age-of-mcp","classic"],
  summary: "Low-poly boar.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.14,
  parts: () => partsFor(),
  animations: [],
});
